import { useQuery } from "@hooks/useQuery";
import { DatePicker, message, Pagination, Switch, TableColumnsType, Typography } from "antd";
import { get as _get, debounce } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DataTable } from "~/Components";
import ConfirmationModal from "~/Components/Modal/confirmation-modal";
import { TableDrawer } from "~/Components/TableDrawer/TableDrawer";
import { useNotification } from "~/Hooks/useNotification";
import { eramanBEApi, post } from "~/Services";
import { eramanApiURL } from "~/Utils";
import ActionDropdown, { TypeData } from "~/Utils/ActionDropdown";
import { drilldownData, ModuleConfig } from "~/Utils/drilldownData";
import { renderActionsColumn, renderDateColumn } from "~/Utils/TableRenderFunction";
import { createExportHandler } from "../NewsLetterSubscription/NewsLetterSubscription";
import { useMemberDocumentDetails } from "./Members.hook";

const { RangePicker } = DatePicker;
export const MembersTab = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [data, setData] = useState<any[]>([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  console.log("sleectedRowData", selectedRowData);
  const [searchString, setSearchString] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sortOrder, setSortOrder] = useState<string>("desc");
  const [orderByName, setOrderByName] = useState<string>("subscribedAt");
  const [selectedSuspendedType, setSelectedSuspendedType] = useState<any>("");
  const [selectedEpcType, setSelectedEpcType] = useState<any>("");
  const [startDateType, setStartDateType] = useState<any>("");
  const [endDateType, setEndDateType] = useState<any>("");
  const [epcId, setId] = useState<string | undefined>(selectedRowData?.approvalId);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [updateSubscriptionModalData, setUpdateSubscriptionModalData] = useState<{ record: any; value: any } | null>(
    null
  );
  const [pageSize, setPageSize] = useState<number>(10);
  const { openToast } = useNotification();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectionStarted, setSelectionStarted] = useState(false);

  const suspendedType: TypeData[] = [
    {
      label: "Subscribed",
      value: "Subscribed",
    },
    {
      label: "Unsubscribed",
      value: "Unsubscribed",
    },
  ];
  const epcType: TypeData[] = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
  ];

  const {
    data: drilldown,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchDocument,
  } = useMemberDocumentDetails(epcId || "");

  console.log("Users-hook", data, selectedRowData, drilldown);

  useEffect(() => {
    if (epcId) {
      refetchDocument();
    }
  }, [epcId]);

  useEffect(() => {
    setId(selectedRowData?.epcId);
  }, [selectedRowData]);

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
    setCurrentPage(1);
  }, 1000);

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, currentPage, pageSize);
  }, [
    query?.get("activeTab"),
    selectedSuspendedType,
    startDateType,
    endDateType,
    searchString,
    sortOrder,
    orderByName,
    pageSize,
    currentPage,
  ]);

  const getRecords = (
    sortOrder: string,
    orderByParam: string,
    searchString: any,
    currentPage?: number,
    pageSize?: number
  ) => {
    setIsLoading(true);
    let url = `admin/subscriptions?pageNo=${currentPage}&pageSize=${pageSize || 10}&sortBy=${orderByParam ? orderByParam : ""}&sortOrder=${sortOrder ? sortOrder : ""}&type=${selectedSuspendedType || ""}&hasEpc=${selectedEpcType || ""}&startDate=${startDateType || ""}&endDate=${endDateType || ""}&search=${searchString || ""}&isMember=true`;
    eramanBEApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data.data;
          setTotalRecords(res.data.totalRows);
          console.log("envelopes", envelopes);
          setData(envelopes);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setData([]);
        setIsLoading(false);
      });
  };

  const columns: TableColumnsType = [
    {
      title: "EPC Id",
      dataIndex: "epcId",
      key: "epcId",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "epcId"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "epcId"
            ? "descend"
            : undefined,
    },
    // {
    //   title: "Name",
    //   dataIndex: "userName",
    //   key: "userName",
    //   sorter: true,
    //   sortOrder:
    //     sortOrder === "asc" && orderByName === "userName"
    //       ? "ascend"
    //       : sortOrder === "desc" && orderByName === "userName"
    //         ? "descend"
    //         : undefined,
    // },
    {
      title: "Name",
      dataIndex: "firstName",
      key: "firstName",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "firstName"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "firstName"
            ? "descend"
            : undefined,
    },
    {
      title: "Email",
      dataIndex: "emailAddress",
      key: "emailAddress",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "emailAddress"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "emailAddress"
            ? "descend"
            : undefined,
    },
    // {
    //   title: "NRIC",
    //   dataIndex: "nric",
    //   key: "nric",
    //   sorter: true,
    //   sortOrder:
    //     sortOrder === "asc" && orderByName === "nric"
    //       ? "ascend"
    //       : sortOrder === "desc" && orderByName === "nric"
    //         ? "descend"
    //         : undefined,
    // },
    // {
    //   title: "Passport",
    //   dataIndex: "passportNumber",
    //   key: "passportNumber",
    //   sorter: true,
    //   sortOrder:
    //     sortOrder === "asc" && orderByName === "passportNumber"
    //       ? "ascend"
    //       : sortOrder === "desc" && orderByName === "passportNumber"
    //         ? "descend"
    //         : undefined,
    // },
    // {
    //     title: "D.O.B",
    //     dataIndex: "dateOfBirth",
    //     key: "dateOfBirth",
    //     sorter: true,
    //     sortOrder:
    //       sortOrder === "asc" && orderByName === "dateOfBirth"
    //         ? "ascend"
    //         : sortOrder === "desc" && orderByName === "dateOfBirth"
    //           ? "descend"
    //           : undefined,
    // },
    // {
    //     title: "Suspended",
    //     dataIndex: "suspended",
    //     key: "suspended",
    //     render: renderPublishedColumn
    // },
    // {
    //     title: "Date of Joined",
    //     dataIndex: "joinedDate",
    //     key: "joinedDate",
    //     render: renderDateColumn,
    //     sorter: true,
    //     sortOrder:
    //       sortOrder === "asc" && orderByName === "joinedDate"
    //         ? "ascend"
    //         : sortOrder === "desc" && orderByName === "joinedDate"
    //           ? "descend"
    //           : undefined,
    // },
    {
      title: "Subscription Date",
      dataIndex: "subscribedAt",
      key: "subscribedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subscribedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subscribedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Unsubscription Date",
      dataIndex: "unsubscribedAt",
      key: "unsubscribedAt",
      render: renderDateColumn,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "unsubscribedAt"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "unsubscribedAt"
            ? "descend"
            : undefined,
    },
    {
      title: "Subscription Status",
      dataIndex: "subscription",
      key: "subscription",
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "subscription"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "subscription"
            ? "descend"
            : undefined,
      render: (value: any, record: any) =>
        isLoading ? null : (
          <Switch
            checked={value.toLowerCase() === "subscribed"}
            onChange={() => setUpdateSubscriptionModalData({ record, value })}
          />
        ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_: any, record: any) => {
        console.log("record", record);
        return renderActionsColumn(
          record,
          setSelectedRowData,
          setDrawerVisible,
          undefined,
          undefined,
          setDeleteModalVisible,
          "users"
        );
      },
    },
  ];

  const handleTableSort = (column: any, sortOrder: string) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    // setCurrentPage(1);
    // getRecords(order, column.dataIndex, searchString, currentPage);
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    if (apiUrl === "") return;

    const payload = {
      action: action,
      method: method,
      module: "Newsletter Subscirptions",
      subModule: "registeredUsers",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: data,
      status: status,
    };

    post("/management/publish", payload)
      .then((response) => {
        openToast({
          content: "Data Sent for Review",
          type: "success",
        });
        navigate("/dedicated/status-information?activeTab=pending");
      })
      .catch((err: any) => {
        openToast({
          content: "Failed to send data",
          type: "error",
        });
      });
  };

  async function sendDeleteUserRequest(reviewNotes: string) {
    try {
      await onSubmit(
        selectedRowData,
        `${eramanApiURL}/admin/subscriptions?id=${selectedRowData?.id}`,
        "DELETE",
        "DELETE",
        "PENDING",
        reviewNotes
      );
    } catch (err) {}
  }

  async function sendUpdateUserRequest() {
    if (!!updateSubscriptionModalData) {
      const subscriptionUrl = `/common/subscribe`;
      const unSubscriptionUrl = `/common/unsubscribe`;
      const method = updateSubscriptionModalData.value.toLowerCase() === "subscribed" ? "GET" : "POST";
      try {
        let response;

        if (method === "GET") {
          response = await eramanBEApi.get(unSubscriptionUrl, {
            params: {
              emailAddress: updateSubscriptionModalData.record.emailAddress,
            },
          });
        } else {
          response = await eramanBEApi.post(subscriptionUrl, {
            emailAddress: updateSubscriptionModalData.record.emailAddress,
          });
        }
        getRecords(sortOrder, orderByName, searchString, currentPage, pageSize);

        openToast({
          content: "Data Saved Successfully",
          type: "success",
        });
      } catch (error: any) {
        console.error("Error:", error);

        if (error.response) {
          const errorMessage = error.response.data || "An unexpected error occurred.";
          message.error(errorMessage);
        } else {
          message.error("Network error or server not reachable.");
        }
      }
    }
  }

  // Updated handleExportData
  async function handleExportData(isExportAll: boolean) {
    try {
      const baseApiUrl = `/admin/subscriptions?sortBy=${orderByName ?? ""}&sortOrder=${sortOrder ?? ""}&type=${selectedSuspendedType ?? ""}&startDate=${startDateType ?? ""}&endDate=${endDateType ?? ""}&search=${searchString ?? ""}&isMember=true`;

      const apiUrl = isExportAll ? baseApiUrl : `${baseApiUrl}&pageNo=${currentPage}&pageSize=${pageSize || 10}`;

      await createExportHandler(
        eramanBEApi,
        apiUrl,
        columns,
        "REGISTERED_USERS",
        isExportAll ? [] : selectedRowKeys,
        isExportAll ? totalRecords : undefined
      );
    } catch (error) {
      openToast({
        content: "Failed to export data",
        type: "error",
      });
    }
  }

  const excludedFields = ["dateOfBirth", "passportNumber", "nric"];

  return (
    <>
      <DataTable
        tabOffset={60}
        columns={columns.map((col: any) => ({
          ...col,
          onHeaderCell: (column: any) => (col.sorter ? { onClick: () => handleTableSort(col, sortOrder) } : {}),
        }))}
        className="table-clickable"
        tableData={
          data
            ? data?.map((d: any) => {
                return {
                  ...d,
                  key: d.id,
                };
              })
            : []
        }
        isLoading={isLoading}
        exportFileName="REGISTERED_USERS"
        exportHandler={handleExportData}
        totalRecords={totalRecords}
        selectedRowKeys={selectedRowKeys}
        onSelectionChange={setSelectedRowKeys}
        isPagination={true}
        recordsPerPage={10}
        multiSelect={true}
        hideExport={false}
        onClick={(record) => {
          setSelectedRowData(record);
        }}
        isServerSearchApi={true}
        searchPlaceholderText={"Search EPC Id/ Name/ Email"}
        onSearchChange={handleSearchChange}
        additionalCTA={
          <div className="flex items-center space-x-2">
            <div className="relative w-80">
              <RangePicker
                value={[startDateType ? moment(startDateType) : null, endDateType ? moment(endDateType) : null]}
                onChange={(dates, dateStrings) => {
                  const [start, end] = dateStrings;
                  setStartDateType(start ? moment(start).format("YYYY-MM-DD") : "");
                  setEndDateType(end ? moment(end).format("YYYY-MM-DD") : "");
                  setCurrentPage(1);
                  if (!start && !end) setSelectionStarted(false);
                }}
                onCalendarChange={(dates) => {
                  if (dates && dates[0]) setSelectionStarted(true);
                }}
                format="YYYY-MM-DD"
                placeholder={["", ""]}
                allowEmpty={[true, true]}
                className="w-full"
                onKeyDown={(e) => e.preventDefault()}
                disabledDate={(current) => {
                  if (!current) return false;
                  const today = moment().endOf("day");
                  if (current > today) return true;
                  if (startDateType && !endDateType) {
                    return current < moment(startDateType, "YYYY-MM-DD");
                  }
                  if (!startDateType && endDateType) {
                    return current > moment(endDateType, "YYYY-MM-DD");
                  }
                  return false;
                }}
              />

              {/* white-background placeholder overlay */}
              {!(selectionStarted || startDateType || endDateType) && (
                <span
                  style={{
                    position: "absolute",
                    left: 12,
                    right: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "#ffffff",
                    padding: "0 8px",
                    zIndex: 2,
                    pointerEvents: "none",
                    color: "#9CA3AF",
                    fontSize: 14,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  Select Subscription Start & End Dates
                </span>
              )}
            </div>

            <ActionDropdown
              value={selectedSuspendedType}
              options={suspendedType}
              onChange={(value) => {
                setSelectedSuspendedType(value);
                setCurrentPage(1);
              }}
              placeholder="Select Subscription Status"
            />
          </div>
          // <div className="flex items-center space-x-2">
          //   <RangePicker
          //     value={[startDateType ? moment(startDateType) : null, endDateType ? moment(endDateType) : null]}
          //     onChange={(dates, dateStrings) => {
          //       const [start, end] = dateStrings;
          //       setStartDateType(start ? moment(start).format("YYYY-MM-DD") : "");
          //       setEndDateType(end ? moment(end).format("YYYY-MM-DD") : "");
          //       setCurrentPage(1);
          //     }}
          //     format="YYYY-MM-DD"
          //     placeholder={["Select Start Date", "Select End Date"]}
          //     className="mr-2 w-80"
          //     onKeyDown={(e) => e.preventDefault()}
          //     disabledDate={(current) => current && current > moment().endOf("day")}
          //   />

          //   <ActionDropdown
          //     value={selectedSuspendedType}
          //     options={suspendedType}
          //     onChange={(value) => {
          //       setSelectedSuspendedType(value);
          //       setCurrentPage(1);
          //     }}
          //     placeholder="Select Subscription Status"
          //   />
          // </div>
        }
      />
      <div className="pagination">
        <Pagination
          defaultCurrent={1}
          current={currentPage}
          total={totalRecords}
          pageSize={pageSize}
          // onChange={(curPage) => {
          //   let page = curPage;
          //   setCurrentPage(page);
          //   // getRecords(sortOrder, orderByName, searchString, page);
          // }}
          onChange={(curPage, newPageSize) => {
            console.log("newPageSize", newPageSize, curPage);
            setCurrentPage(curPage);
            if (newPageSize !== pageSize) {
              setPageSize(newPageSize);
              setCurrentPage(1);
            }
          }}
          showSizeChanger
          pageSizeOptions={["10", "20", "50", "100"]}
        />
      </div>
      <TableDrawer
        title={
          <Typography.Title
            level={4}
            className={"!mb-0"}
          >
            Detailed View
          </Typography.Title>
        }
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        fields={drilldownData[_get(drilldown, "subModule", "registeredUsers") as ModuleConfig].filter(
          (field) => !excludedFields.includes(field.fieldValue as string)
        )}
        data={{ ...drilldown, ...selectedRowData }}
      />

      <ConfirmationModal
        type="delete"
        open={deleteModalVisible}
        onClose={() => setDeleteModalVisible(false)}
        onSubmit={sendDeleteUserRequest}
      />
      <ConfirmationModal
        type="save"
        open={!!updateSubscriptionModalData}
        onClose={() => setUpdateSubscriptionModalData(null)}
        onSubmit={sendUpdateUserRequest}
      />
    </>
  );
};
